/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

/*
 * IMPORTS
 */

import $ from 'jquery';
import * as vars from '../../globals/variables';
import {params} from './params/params';
import {getAllUrlParams, getUrlParameter} from "../../utilities/lib/general";

/*
 * YOUR CODE
 */

//Bei globalDynForms nur den Dynfromcode des Wrappers verwenden
let globalDynForms = {
    'std_request_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_request + '&L=' + vars.lang_id,
        additionals: false,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Farbe der Input Labels, Farbe des Kalenders, Section Linie
            'color2': vars.dynformsColors.colorTEXT, // Farbe des Section Titels, Farbe der Zimmerbeschreibung, Farbe Beschreibungstext Einwilligung Marketing/Profilierung, Hoverfarbe X Zimmer entfernen
            'color3': vars.dynformsColors.colorSECONDARY, // Hintergrundfarbe Absenden Button, Hoverfarbe Absenden Button, Farbe des Popups beim Hovern
            'color4': vars.dynformsColors.colorTEXT, // Farbe Input Felder, Farbe des Popup, Titel Zimmername
            'color5': vars.dynformsColors.colorPRIMARY, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern, Farbe Checkbox Icon ausgewählt, Hintergrundfarbe Popup
            'color6': vars.dynformsColors.colorTEXT, // Farbe Einwilligung Marketing/Profilierung + Checkbox Border
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        additionalData: {
            minDate: new Date(2023, 4, 1),
            maxDate: new Date(2023, 9, 1),
            disable: [
                function(date) {
                    const minDate = new Date(2022, 6, 23); // 23.07.22
                    const maxDate = new Date(2022, 8, 3); // 3.09.22
                    // for Dates between 23.07.22 - 3.09.22 disable mon, tue, thu, fri (only sat, sun and wed should be enabled)
                    if (date.getTime() >= minDate.getTime() && date.getTime() <= maxDate.getTime()) {
                        return (date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 4 || date.getDay() === 5);
                    }
                }
            ]
        },
        buttonTypes: 1,
        offer_id: params.offer,
        last_minute: params.lastminute_code,
        roomcodes: params.roomcodes,
        fieldOverride: {
            fromdate: params.fromdate,
            todate: params.todate
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            if(container.classList.contains('popupForm')) {
                let slider = container.closest('.slick-list');
                slider.style.height = "auto";
            }
        }
    },
    'std_quickrequest_2017_rooms': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_quick_request + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorSECONDARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color2': vars.dynformsColors.colorTEXT, // Farbe Input Labels & Inputs
            'color3': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        onFormReady: function () {

        },
        onBeforeSubmit: (container, config) => {

        }
    },
    'std_newsletter_2017': {
        urlSuccess: '/index.php?id=' + vars.ts.pids.success_newsletter + '&L=' + vars.lang_id,
        colors: {
            'color1': vars.dynformsColors.colorCustom, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorCustom, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    }
};

//Bei specialDynforms nur die IDs des Wrappers verwenden
let specificDynforms = {
    'bn_quickrequest_vertical': {
        colors: {
            'color1': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color2': vars.dynformsColors.colorCustom, // Farbe Input Labels & Inputs
            'color3': vars.dynformsColors.colorPRIMARY, // Hintergrundfarbe Absenden Button
            'color4': vars.dynformsColors.colorCustom, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        },
        additionalData: {
            minDate: new Date(2022, 4, 1)
        },
        onFormReady: function () {
            const container = document.getElementById(this.formContainerId);
            $(document).on('body', 'click', function () {
                if($(container).find('.flatpickr-input').hasClass('active')) {
                    $(container).closest('.bn-quick-request__form').addClass('of_visible');
                } else {
                    $(container).closest('.bn-quick-request__form').removeClass('of_visible');
                }

            });
            $(container).find('.bn-form__column--children').on('click', function () {
                $(container).find('.bn-form__column--children').each( function () {
                    let counter = 0;
                    $(this).find('select').find('option').each( function () {
                        if (counter > 12) {
                            $(this).addClass('hidden');
                        }
                        counter ++;
                    });
                });
            });

            let roomCode = getUrlParameter('room_code');

            if (roomCode) {
                setTimeout(function(){
                    $(container).find('input').attr('checked', false);
                    $(container).find(`input[name="${roomCode}"]`).attr('checked', true);
                }, 500);
            }
        },
        onBeforeSubmit: (container, config) => {
            /*const from = document.querySelector('#bn_quickrequest_vertical_fromdate').value.split('.').reverse().join().replace(',', '-')
                .replace(',', '-');
            const to = document.querySelector('#bn_quickrequest_vertical_todate').value.split('.').reverse().join().replace(',', '-')
                .replace(',', '-');
            const lastname = document.querySelector('#bn_quickrequest_vertical_lastname').value;
            const firstname = document.querySelector('#bn_quickrequest_vertical_firstname').value;
            const mail = document.querySelector('#bn_quickrequest_vertical_email').value;
            if (from !== '' && to !== '' && lastname !== '' && firstname !== '' && mail !== '') {
                if (document.querySelector('.bn-request__optionals[data-optionals-title="optional"] .js-active')) {
                    let text = `\n\n${vars.ts.text.board}: `;
                    document.querySelectorAll('.bn-request__optionals[data-optionals-title="optional"] .js-active').forEach(function (element) {
                        const valTranslated = element.getAttribute('data-value-translated');
                        text += `${valTranslated}, `;
                    });
                    document.querySelector('#bn_quickrequest_vertical_custom_comment').value += text.substring(0, text.length - 2);
                }
            }*/
            let fromDate = $('#bn_quickrequest_vertical_fromdate').val(),
                toDate = $('#bn_quickrequest_vertical_todate').val();

            fromDate = fromDate.split('.');
            toDate = toDate.split('.');

            const fromDateTime = new Date(fromDate[2], fromDate[1] - 1, fromDate[0]),
                toDateTime = new Date(toDate[2], toDate[1] - 1, toDate[0]),
                disableFromDate = new Date(2021, 8 - 1, 8),
                disableToDate = new Date(2021, 8 - 1, 22);

            if ($('.bn_quickrequest').find('[name="23577"]').is(':checked') && ((fromDateTime >= disableFromDate && fromDateTime <= disableToDate) || (toDateTime >= disableFromDate && toDateTime <= disableToDate))) {
                alert(vars.ts.text.not_bookable);
                return false;
            }
        }
    },
    'bn_newsletter_v3': {
        colors: {
            'color1': vars.dynformsColors.colorTEXT, // Farbe der Input Felder & Input Labels
            'color2': vars.dynformsColors.colorACTION, // Hintergrundfarbe Absenden Button, Farbe Popup Text beim Hovern
            'color3': '#eff5f6', // Hintergrundfarbe Formular, Hintergrundfarbe Popup
            'color4': vars.dynformsColors.colorTEXT, // Farbe Absenden Button, Hintergrundfarbe Absenden Button beim Hovern
            'colorValid': vars.dynformsColors.colorValid, // Farbe der Input Labels wenn ein Feld korrekt ausgefüllt worden ist,
            'colorError': vars.dynformsColors.colorError // Farbe der Input Labels wenn ein Feld falsch ausgefüllt worden ist
        }
    }
};

export {
    globalDynForms,
    specificDynforms
};



// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/config.js